common.View.create('crud::form.inputs.Slug', {

    onDOMLoad() {
        this.initGui();
    },

    /**
     * The field's own slug input(s). Not every input in the component: the path
     * builder renders chips and hidden slug_path[...] inputs inside the same root.
     */
    slugInputs() {
        return this.element.find('input[data-slug-input]');
    },

    initGui() {
        // Data prepend on input?
        let dataPrepend = this.slugInputs().data('prepend');

        this.slugInputs().each((key, value) => {
            // Get current input value
            let $currentValue = $(value).val();

            // When user is typing
            $(document).on('keyup', 'input[name="' + $(value).data('trigger') + '"]', (event) => {
                this.changeValueToSlug(value, dataPrepend, $currentValue, event);
            });

            $(value).on('keyup', (event) => {
                this.changeValueToSlug(value, dataPrepend, $currentValue, event);
            });

            // Tidy what the live slugify deliberately leaves alone while typing:
            // doubled dashes from inserting a separator mid-word, and the trailing
            // one left behind by a space. Doing either on keystroke would collapse
            // the dash as you type it and bounce the caret to the end.
            $(value).on('blur', (event) => {
                $(value).val(
                    event.currentTarget.value
                        .replace(/-{2,}/g, '-')
                        .replace(/[-\/]+$/g, '')
                );
                value.dispatchEvent(new Event('input', { bubbles: true }));
            });

        });
    },

    changeValueToSlug(value, dataPrepend, $currentValue, event) {
        // when input is readonly and there is a value dont change slug
        if ($(value).prop('readonly') && $currentValue) {
            return;
        }

        // when not readonly allow slug to be changed
        if ($(event.currentTarget).prop('readonly') !== true) {
            let addVal = '';

            // Check if prepend is added, if so don't edit if user doesn't specifically does
            if (dataPrepend && !$(event.currentTarget).data('trigger')) {
                addVal = dataPrepend;
            }

            // Typing straight into the slug field, rather than it being filled from
            // the trigger. Then there is a caret to protect and dash runs must
            // survive, or inserting a separator mid-word is impossible.
            let direct = event.currentTarget === value;

            // Slugify value?
            let newValue = $(value).data('slugify')
                ? addVal + this.slugify(event.currentTarget.value, direct)
                : addVal + event.currentTarget.value;

            if (newValue === value.value) {
                return;
            }

            let caret = direct ? value.selectionStart : null;
            let lengthBefore = value.value.length;

            $(value).val(newValue);

            // Writing the value back puts the caret at the end, which throws you out
            // of the word you were editing. Put it back where you were typing.
            if (direct) {
                let next = Math.max(0, caret - (lengthBefore - newValue.length));
                value.setSelectionRange(next, next);
            }

            // jQuery's .val() fires nothing, so anything watching the field (the
            // slug path builder's preview) would keep showing the previous value.
            value.dispatchEvent(new Event('input', { bubbles: true }));
        }
    },

    /** keepDashRuns: leave "--" alone while typing; blur collapses it. */
    slugify(str, keepDashRuns = false) {
        // Leading only. Trimming the trailing space too would swallow the word
        // break the moment you press space, so typing straight into a slug field
        // ran the words together. The trailing dash is cleaned up on blur.
        str = str.replace(/^\s+/, '');

        // Make the string lowercase
        str = str.toLowerCase();

        // Remove dirs?
        if (!this.slugInputs().data('allow-dir')) {
            str = str.replace(/\//g, '-');
        }

        // Get trigger. Falls back to empty when the field has no trigger, or the
        // trigger is not on the page — otherwise every keystroke throws here.
        let triggerField = this.slugInputs().data('trigger');
        let triggerValue = ((triggerField ? $('input[name="'+triggerField+'"]').val() : '') || '').toLowerCase();

        // Remove accents, swap ñ for n, etc
        let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;&";
        let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa-/-----";

        // Then handle triggerValue specific case
        if (triggerValue.includes('/')) {
            let triggerValueIndex = str.indexOf(triggerValue);
            if (triggerValueIndex !== -1) {
                while (triggerValue.includes('/')) {
                    let slashIndexInTriggerValue = triggerValue.indexOf('/');
                    let slashIndexInStr = triggerValueIndex + slashIndexInTriggerValue;
                    str = str.substring(0, slashIndexInStr) + '-' + str.substring(slashIndexInStr + 1);
                    triggerValue = triggerValue.substring(0, slashIndexInTriggerValue) + '-' + triggerValue.substring(slashIndexInTriggerValue + 1);
                }
            }
        }

        // Then handle the last slash in the string, if it's not part of triggerValue
        if (str.lastIndexOf('/') > str.indexOf(triggerValue) + triggerValue.length - 1) {
            let lastSlashIndex = str.lastIndexOf('/');
            str = str.substring(0, lastSlashIndex) + '-' + str.substring(lastSlashIndex + 1);
        }

        // Replace special chars on the end.
        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        // Remove invalid chars
        str = str.replace(/[^\w-\/ ]+/g, '')
            // Collapse whitespace and replace by -
            .replace(/\s+/g, '-');

        if (!keepDashRuns) {
            // Collapse dashes
            str = str.replace(/-+/g, '-');
        }

        str = str
            // Replace multiple slashes
            .replace(/[/_,]+/g, '/')
            // And replace first and last slash with nothing
            .replace(/^\//g, '');

        $(this).val(str);

        return str;
    },
});
